module.exports = __webpack_public_path__ + "static/img/作品63.e3913a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品63.png
// module id = GM6T
// module chunks = 1